const ACTOR_ROLE = {
  AGENT: 'AGENT',
  OPS: 'OPS',
  SUPPLY: 'SUPPLY',
  DEMAND: 'DEMAND',
  TENANT_LIVING: 'TENANT_LIVING',
};

export default ACTOR_ROLE;
